<div class="page-body">
  <router-outlet></router-outlet>
</div>
@if (blueLightFilter()) {
<div class="blue-light-filter" @fade></div>
}
<!-- @if (isMobile()) {
  <pi-mobile-view-blocker />
} -->
